import type { RouteRecordRaw } from "vue-router";
import { ROUTE_NAME } from "@/shared/constants/routes";

export const routes: RouteRecordRaw[] = [
  {
    path: "/profile",
    name: ROUTE_NAME.PROFILE_UPDATE,
    component: () => import("./views/ProfileUpdate.vue"),
  },
];
